import type { SxProps, Theme } from "@mui/material";
import { MenuItem, TextField } from "@mui/material";
import { useActiveProductSizes } from "../hooks/useProductChanges";

interface ProductSizeSelectorProps {
	value: number | null;
	onChange: (value: number | null) => void;
	label?: string;
	fullWidth?: boolean;
	size?: "small" | "medium";
	required?: boolean;
	error?: boolean;
	helperText?: string;
	disabled?: boolean;
	sx?: SxProps<Theme>;
}

export const ProductSizeSelector = ({
	value,
	onChange,
	label = "Product",
	fullWidth = false,
	size = "small",
	required = false,
	error = false,
	helperText,
	disabled = false,
	sx,
}: ProductSizeSelectorProps) => {
	const { data: productSizes = [], isLoading } = useActiveProductSizes();

	return (
		<TextField
			select
			label={label}
			value={value ?? ""}
			onChange={(e) =>
				onChange(e.target.value === "" ? null : Number(e.target.value))
			}
			size={size}
			fullWidth={fullWidth}
			required={required}
			disabled={disabled || isLoading}
			error={error}
			helperText={helperText}
			sx={
				{
					minWidth: 120,
					width: fullWidth ? "100%" : undefined,
					...sx,
				} as SxProps<Theme>
			}
			slotProps={{
				inputLabel: { shrink: true },
				select: {
					sx: { width: "100%" },
				},
			}}
		>
			{!required && (
				<MenuItem value="">
					<em>None</em>
				</MenuItem>
			)}
			{productSizes.map((ps) => (
				<MenuItem key={ps.Id} value={ps.Id}>
					{ps.Name}
				</MenuItem>
			))}
		</TextField>
	);
};
